import { AppModuleManagement } from '../models';


export class CreateAppModule {
    static readonly type = '[AppModuleManagement] create app-module';
    constructor(public payload: AppModuleManagement.CreateAppModuleRequest) {

    }
}

export class UpdateAppModule {
    static readonly type = '[AppModuleManagement] update app-module';
    constructor(public payload: AppModuleManagement.UpdateAppModuleRequest) {

    }
}

export class DeleteAppModule {
    static readonly type = '[AppModuleManagement] delete app-module';
    constructor(public id: string) {

    }
}

export class GetAppModule {
    static readonly type = '[AppModuleManagement] get app-module';
    constructor(public id: string) {

    }
}

export class GetList {
    static readonly type = '[AppModuleManagement] getlist app-module';
    constructor(public payload: AppModuleManagement.GetAppModuleRequest) {

    }
}